<template>
  <b-sidebar
    v-model="sidebarVisible"
    right
    shadow
    backdrop
    bg-variant="white"
    no-header
    width="500px"
  >
    <template>
      <div class="container sidebar-header">
        <b-row>
          <div class="col">
            <h4>Import Storefront Orders</h4>
          </div>
          <div class="col-auto text-right">
            <b-button
              variant="outline-secondary"
              @click="closeSidebar"
            >
              <i class="fa fa-times"></i>
            </b-button>
          </div>
        </b-row>
      </div>

      <div class="px-3 py-2 manualshipment-importoverlay">
        <b-form @submit.prevent="handleImport">
          <b-form-group label="Storefront:" label-for="import-storefront">
            <b-v-select
              id="import-storefront"
              v-model="importForm.storefrontId"
              :searchable="true"
              :options="projectsActiveFilter"
              :required="true"
            />
          </b-form-group>

          <b-form-group
            v-if="importForm.storefrontId"
            label="Order Group:"
            label-for="import-order-group"
          >
            <b-v-select
              id="import-order-group"
              v-model="importForm.orderGroupId"
              :searchable="true"
              :options="orderGroupsFilter"
              :required="false"
            />
          </b-form-group>

          <b-form-group label="Import Method:" label-for="import-mapping-method">
            <b-v-select
              id="import-mapping-method"
              v-model="importForm.importSheetMappingMethodId"
              :searchable="true"
              :options="importSheetMappingMethodsFilter"
              :required="false"
            />
          </b-form-group>

          <b-form-group label="Excel File:" label-for="import-formFile">
            <b-form-file
              id="import-formFile"
              v-model="importForm.formFile"
              accept=".xlsx,.xls"
              placeholder="Choose a file or drop it here..."
              drop-placeholder="Drop file here..."
              :required="true"
            ></b-form-file>
            <div v-if="!importForm.importSheetMappingMethodId">
              <small class="form-text text-muted">
                You can <a href="/bulkship_import_example_default.xlsx" target="_blank" download>
                  <i class="fa fa-download mr-1"></i>
                  download a sample spreadsheet
                </a> here.
              </small>
            </div>
          </b-form-group>

          <div class="mt-3">
            <b-button
              type="submit"
              variant="primary"
              :disabled="!canSubmitImport || importLoading"
              block
            >
              <b-spinner small v-if="importLoading" class="mr-2"></b-spinner>
              {{ importLoading ? 'Importing...' : 'Import' }}
            </b-button>
          </div>
        </b-form>

        <div v-if="importResults" class="mt-4">
          <h5>Import Results</h5>
          <b-alert :variant="importResults.success ? 'success' : 'warning'" show>
            <div v-if="importResults.success">
              Successfully imported {{ importResults.item.totalProcessed }} orders!
            </div>
            <div v-else>
              Processed {{ importResults.item.totalProcessed }} orders:
              <ul class="mb-0">
                <li>Successful: {{ importResults.item.successfulImports }}</li>
                <li>Failed: {{ importResults.item.failedImports }}</li>
              </ul>
            </div>
          </b-alert>

          <div v-if="importResults.item.results && importResults.item.results.length > 0" class="mt-3">
            <h6>Details:</h6>
            <div class="import-results-list" style="max-height: 300px; overflow-y: auto;">
              <div v-for="(result, index) in importResults.item.results" :key="index" class="mb-2">
                <b-badge :variant="result.success ? 'success' : 'danger'">
                  {{ result.orderNumber }}
                </b-badge>
                <span v-if="result.success" class="ml-2 text-success">
                  <i class="fa fa-check"></i> Imported
                </span>
                <span v-else class="ml-2 text-danger">
                  <i class="fa fa-times"></i> {{ result.errorMessage }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </b-sidebar>
</template>

<script>
import { myCommonDataMixin } from '@/helpers/utils/vueMixins.js';

export default {
  name: 'StorefrontOrdersImportSidebar',
  mixins: [myCommonDataMixin],
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      importLoading: false,
      importResults: null,
      importForm: {
        storefrontId: '',
        orderGroupId: '',
        importSheetMappingMethodId: null,
        formFile: null
      },
      importSheetMappingMethods: [],
      loadingMappingMethods: false
    };
  },
  computed: {
    sidebarVisible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    },
    canSubmitImport() {
      return (
        this.importForm.storefrontId &&
        this.importForm.formFile
      );
    },
    orderGroupsFilter() {
      var arrs = [{ value: '', text: 'Default' }];
      if (this.importForm.storefrontId) {
        var filtered = this.myStores.filter(
          function (s) { return s.projectId === this; },
          this.importForm.storefrontId
        );
        filtered.forEach(function (itm) {
          arrs.push({ value: itm.id, text: itm.storeName });
        });
      }
      return arrs;
    },
    importSheetMappingMethodsFilter() {
      let filteredMethods = this.importSheetMappingMethods;
        filteredMethods = filteredMethods.filter(a => a.brandId == null || a.type == 'StorefrontOrderImport');
      const mappingOptions = filteredMethods.map(method => ({
        value: method.id,
        text: method.name
      }));
      return mappingOptions;
    }
  },
  watch: {
    value(newVal) {
      if (newVal) {
        this.resetForm();
      }
    },
    'importForm.storefrontId': function () {
      this.importForm.orderGroupId = '';
    }
  },
  mounted() {
    this.loadImportSheetMappingMethods();
  },
  methods: {
    closeSidebar() {
      this.sidebarVisible = false;
    },
    resetForm() {
      this.importResults = null;
      this.importForm = {
        storefrontId: '',
        orderGroupId: '',
        importSheetMappingMethodId: null,
        formFile: null
      };
    },
    handleImport() {
      if (!this.canSubmitImport) return;

      this.importLoading = true;
      this.importResults = null;

      const formData = new FormData();
      formData.append('formFile', this.importForm.formFile);
      formData.append('storefrontId', this.importForm.storefrontId);
      if (this.importForm.orderGroupId) {
        formData.append('orderGroupId', this.importForm.orderGroupId);
      }
      if (this.importForm.importSheetMappingMethodId) {
        formData.append('importSheetMappingMethodId', this.importForm.importSheetMappingMethodId);
      }

      this.$http.post('/api/common/storefront-orders/import-via-spreadsheet', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
        .then(response => {
          this.importResults = response.data;
          if (response.data.success) {
            this.$swal('Success', 'Successfully imported ' + response.data.item.successfulImports + ' orders!', 'success');
            this.$emit('import-completed', response.data);
          } else if (response.data.item.failedImports > 0) {
            this.$swal.warning('Imported ' + response.data.item.successfulImports + ' orders, ' + response.data.item.failedImports + ' failed.');
            this.$emit('import-completed', response.data);
          }
        })
        .catch(error => {
          console.error('Import error:', error);
          var errorMsg = (error.response && error.response.data && error.response.data.errorMessage);
          if (!errorMsg) {
            errorMsg = 'Failed to import orders';
          }
          this.$swal('Error', errorMsg, 'error');
        })
        .finally(() => {
          this.importLoading = false;
        });
    },
    loadImportSheetMappingMethods() {
      this.loadingMappingMethods = true;
      this.$http.post('/api/common/import-sheet-mapping-methods/listItems', {
        page: 1,
        perPage: 500,
        type: 'StorefrontOrderImport'
      })
        .then(response => {
          if (response.data && response.data.total && response.data.items) {
            this.importSheetMappingMethods = response.data.items;
          } else {
            this.importSheetMappingMethods = [];
          }
        })
        .catch(error => {
          console.error('Error loading import sheet mapping methods:', error);
          this.importSheetMappingMethods = [];
        })
        .finally(() => {
          this.loadingMappingMethods = false;
        });
    }
  }
};
</script>
